import { countries } from '@getaccept/lib-shared-new/src/countries/constants/countries';
import { DatacenterId } from '@getaccept/lib-shared-new/src/datacenter/enums/datacenter-id';
import { datacenters } from '@getaccept/lib-shared-new/src/datacenter/constants/datacenters';
import { computed, ref, defineComponent, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { DatacenterHelper } from '../../helpers/datacenter.helper';
export default defineComponent({
    name: 'CreateEntityForm',
    props: {
        initialFormData: {
            type: Object,
            default: () => ({
                name: '',
                countryCode: '',
                timezone: '',
                datacenter: DatacenterId.USOregon,
            }),
        },
    },
    emits: ['submit'],
    setup(props, context) {
        const { t } = useI18n();
        const formData = ref({
            name: '',
            countryCode: '',
            timezone: '',
            datacenter: DatacenterId.USOregon,
        });
        const formErrorName = ref('');
        watch(() => formData.value.name, () => (formErrorName.value = ''));
        const countryItems = computed(() => countries.map((country) => (Object.assign(Object.assign({}, country), { labelWithFlag: `${country.flag} ${country.label}` }))));
        const selectedCountry = computed(() => countryItems.value.find(country => country.key === formData.value.countryCode));
        const datacenterItems = computed(() => datacenters.map(datacenter => recommendedDatacenter.value === datacenter.id
            ? Object.assign(Object.assign({}, datacenter), { name: `${datacenter.name} (${t('recommended').toString()})` }) : datacenter));
        const selectedDatacenter = computed(() => datacenterItems.value.find(datacenter => datacenter.id === formData.value.datacenter));
        const recommendedDatacenter = computed(() => DatacenterHelper.getDatacenterFromCountry(formData.value.countryCode).id);
        const handleCountryChange = (value) => {
            formData.value.countryCode = value.key;
        };
        const handleDatacenterChange = (value) => {
            formData.value.datacenter = value.id;
        };
        const validateForm = () => {
            formErrorName.value = !formData.value.name ? t('company-name-is-required').toString() : '';
        };
        const handleSubmit = () => {
            validateForm();
            if (formErrorName.value) {
                return;
            }
            context.emit('submit', formData.value);
        };
        onMounted(() => {
            formData.value = Object.assign({}, props.initialFormData);
        });
        return {
            formData,
            formErrorName,
            selectedCountry,
            countryItems,
            datacenterItems,
            recommendedDatacenter,
            handleCountryChange,
            handleDatacenterChange,
            validateForm,
            selectedDatacenter,
            handleSubmit,
        };
    },
});
